import React from 'react'
import { Box, makeStyles, createStyles, Typography } from '@material-ui/core'

const Place = () => {
  const classes = useStyles()
  return (
    <Box>
      <Typography variant="h6">Place</Typography>
      <Typography variant="body1">
        The Data is processed at the Owner's operating offices and in any other
        places where the parties involved in the processing are located.
        Depending on the User's location, data transfers may involve
        transferring the User's Data to a country other than their own. To find
        out more about the place of processing of such transferred Data, Users
        can check the section containing details about the processing of
        Personal Data. Users are also entitled to learn about the legal basis of
        Data transfers to a country outside the European Union or to any
        international organization governed by public international law or set
        up by two or more countries, such as the UN, and about the security
        measures taken by the Owner to safeguard their Data. If any such
        transfer takes place, Users can find out more by checking the relevant
        sections of this document or inquire with the Owner using the
        information provided in the contact section.
      </Typography>
    </Box>
  )
}

const useStyles = makeStyles((theme) => createStyles({}))

export default Place
